import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { RightPanelComponent } from './right-panel.component';
import { PanelToggleButtonComponent } from './panel-toggle-button/panel-toggle-button.component';
import { RightPanelService } from './right-panel.service';


@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    RightPanelComponent,
    PanelToggleButtonComponent,
  ],
  exports: [
    RightPanelComponent,
    PanelToggleButtonComponent,
  ],
  providers: [
    RightPanelService
  ],
})
export class RightPanelModule {}
